module.exports = __webpack_public_path__ + "img/bookmark-icon.2660ea97.svg";